
// SVG Icon: getting-started-icon
export default { id: "terriajs-getting-started-icon" };
export const id = "terriajs-getting-started-icon";
export const name = "getting-started-icon";
